import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { GridModule, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';

import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { ClientService } from 'src/app/base/services/client/client.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { ProblemReportOrigin } from '../../../base/models/models.swagger.generated';
import { ProblemReportAdministrationService } from './problem-report-administration.service';
import { ProblemReportDetailComponent } from './problem-report-detail/problem-report-detail.component';
import { SearchFieldComponent } from '../../../base/shared/search-field/search-field.component';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';

@Component({
  selector: 'app-problem-report-administration',
  templateUrl: './problem-report-administration.component.html',
  styleUrls: ['./problem-report-administration.component.scss'],
  imports: [
    TitleBarComponent,
    SearchFieldComponent,
    GridModule,
    ProblemReportDetailComponent,
    TranslateModule,
  ]
})
export class ProblemReportAdministrationComponent extends GridBaseComponent implements OnInit {

  public toolbar: ToolbarItems[] | object = ['ColumnChooser'];
  public ProblemReportOrigin = ProblemReportOrigin;

  constructor(
    private problemReportAdministrationService: ProblemReportAdministrationService,
    translateService: TranslateService,
    clientService: ClientService,
    private spinnerService: SpinnerService,
    private fb: UntypedFormBuilder,
  ) {
    super(clientService, translateService, problemReportAdministrationService);
    this.searchOptions = { fields: ['user.firstname', 'user.lastname', 'problemMessage', 'platform'] };
    this.editSettings = {
      allowEditing: true,
      allowAdding: false,
      allowDeleting: true,
      mode: 'Dialog',
      showDeleteConfirmDialog: true,
    };
    this.showSaveButton = false;
    this.editDialogTitle = 'i18n.domain.problem-report-administration.detail.title';
    this.dialogConfig = { width: '90%' };
    this.gridCommands = [
      {
        type: SfCommandButtonType.Edit,
        buttonOption: {
          cssClass: 'icon-btn',
          iconCss: 'icon-edit e-icons',
        },
      },
      {
        type: SfCommandButtonType.Delete,
        buttonOption: {
          cssClass: 'icon-btn',
          iconCss: 'icon-trash-can e-icons e-danger',
        },
      },
    ];
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.problemReportAdministrationService, this.spinnerService),
    });
  }

  protected initializeEditForm(data: any): void {
    this.gridEditForm = this.fb.group({
      id: [data.id],
    });
  }

  protected getEditDialogTitleParams(rowData: any): any {
    return { id: rowData.id };
  }
}
